import React from "react";

// Stylised SVG wordmarks/marks for: ITCS, Dr's V Clinic, Jayathraya Projects

export const LOGO_LIST = [
  {
    name: "ITCS",
    svg: (
      <svg viewBox="0 0 150 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-7">
        <circle cx="14" cy="18" r="11" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="14" cy="18" r="4" fill="currentColor" />
        <text x="34" y="25" fontFamily="Cabinet Grotesk, sans-serif" fontWeight="900" fontSize="22" fill="currentColor" letterSpacing="-0.5">ITCS</text>
      </svg>
    ),
  },
  {
    name: "Dr's V Clinic",
    svg: (
      <svg viewBox="0 0 200 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-7">
        <path d="M4 6 L14 30 L24 6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="14" cy="6" r="2" fill="currentColor" />
        <text x="32" y="25" fontFamily="Cabinet Grotesk, sans-serif" fontWeight="700" fontSize="18" fill="currentColor" letterSpacing="-0.3">Dr&apos;s V Clinic</text>
      </svg>
    ),
  },

  {
    name: "Jayathraya Projects",
    svg: (
      <svg viewBox="0 0 230 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-7">
        <rect x="5" y="10" width="4" height="18" fill="currentColor" rx="1" />
        <rect x="11" y="6" width="4" height="22" fill="currentColor" rx="1" />
        <rect x="17" y="14" width="4" height="14" fill="currentColor" rx="1" />
        <text x="28" y="25" fontFamily="Cabinet Grotesk, sans-serif" fontWeight="800" fontSize="18" fill="currentColor" letterSpacing="-0.3">Jayathraya <tspan fontWeight="500" opacity="0.8">Projects</tspan></text>
      </svg>
    ),
  },
];

export default function TrustedLogos({ tone = "dark" }) {
  const colorClass = tone === "dark" ? "text-white/80 hover:text-white" : "text-ink-soft/65 hover:text-ink-soft";

  return (
    <div className="marquee-wrap overflow-hidden" data-testid="trusted-logos-marquee">
      <div className="flex items-center justify-center gap-16 md:gap-20 w-max animate-marquee mx-auto">
        {[...LOGO_LIST, ...LOGO_LIST, ...LOGO_LIST].map((logo, i) => (
          <div key={i} className={`shrink-0 ${colorClass} transition-colors`} title={logo.name}>
            {logo.svg}
          </div>
        ))}
      </div>
    </div>
  );
}
